import { Fragment, useState, useEffect } from 'react';

import { CaseAsset, CaseReport } from '../../models/CaseTypes';
import { VideoPlayer } from '../common/VideoPlayer';
import { NoVideoAvailable } from '../common/NoVideoAvailable';

const Recording = ({ caseReport }: {caseReport: CaseReport}):
  React.JSX.Element => {
  const [video, setVideo] = useState<CaseAsset | null>(null);

  useEffect(() => {
    if (!caseReport) {
      return;
    }

    if (caseReport.videos && caseReport.videos.length > 0) {
      setVideo(caseReport.videos[0]);
    }
  }, [caseReport]);

  return (
    <Fragment>
      {
        caseReport && !caseReport.videos?.length &&
        <NoVideoAvailable />
      }

      {
        video &&
        <VideoPlayer
          key='segment-video-player'
          videoUrl={video.signedUrl || ''}
          startTimeSeconds={0}
          endTimeSeconds={0}
          segmentTitle="Case Recording"
          caseId={caseReport.id}
        />
      }

    </Fragment>
  );
};
export default Recording;
